import { Button, Tab, Tabs } from '@material-ui/core'
import React from 'react'
import CatalogueWrapper from './Catalogue/CatalogueWrapper'
import QuiltWrapper from './Quilt'
import Stage from '../Stage'
import { Box } from '@material-ui/system'
import PerforationEditor from './Perforation'

const editorSwitcher = (mode: string) => {
  if (Stage) {
    const stage = Stage.getInstance()
    switch (mode) {
      case 'material': {
        return <CatalogueWrapper />
        break
      }
      case 'quilt': {
        return <QuiltWrapper quiltCurrent={stage.state.quilt} />
        break
      }
      case 'perforation': {
        return <PerforationEditor />
      }
      default:
        break
    }
  }
}

const modes = ['material', 'quilt', 'perforation']

const MaterialEditor = () => {
  const [mode, setMode] = React.useState<string>('material')
  const [value, setValue] = React.useState<number>(0)
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue)
    setMode(modes[newValue])
  }
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 100,
        width: { xl: '22vw', lg: '30vw' },
        // minWidth: '15vw',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          width: '100%',
        }}
      >
        <Tabs value={value} onChange={handleChange}>
          {modes.map(m => (
            <Tab label={m} key={m} />
          ))}
        </Tabs>
      </div>
      {editorSwitcher(mode)}
    </Box>
  )
}

export default MaterialEditor
